import { render } from "./ResearchDevelopment.vue?vue&type=template&id=05f73eee"
import script from "./ResearchDevelopment.vue?vue&type=script&lang=js"
export * from "./ResearchDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__